<template>
  <div class="beauty-wrapper">

    <!-- 内容区域 -->
    <div class="beauty-content">

      <!-- 左侧预览图片 -->
      <div class="beauty-picture-preview">
        <img :src="notWatermarkImage || watermarkedPhoto" alt="">
        <span class="line top">150px</span>
        <span class="line right">210px</span>
        <span class="line bottom">25mm</span>
        <span class="line left">35mm</span>
      </div>

      <!-- 右侧操作区域 -->
      <div class="beauty-handle-box">

        <!-- 切换 tab -->
        <div class="beauty-handle-header">
          <span class="beauty-handle-header-sign" :class="tabTypeHeader"></span>
          <h6 :class="{'active': tabTypeHeader === 'background'}" @click="toggleTabHeaderFunc('background')" v-if="!notWatermarkImage">更改底色</h6>
          <h6 :class="{'active': tabTypeHeader === 'fair'}" @click="toggleTabHeaderFunc('fair')" v-if="!notWatermarkImage">人像美颜</h6>
          <h6 :class="{'active': tabTypeHeader === 'clothes'}" @click="toggleTabHeaderFunc('clothes')" v-if="!notWatermarkImage">正装样式</h6>
          <h6 class="active" v-if="notWatermarkImage">简历预览</h6>
        </div>

        <div class="beauty-handle-content">

          <!-- 更改底色 -->
          <div class="background-box" v-show="tabTypeHeader === 'background' && !notWatermarkImage">
            <div class="background-item" :class="{'active': itemBg.en === nowBackground}" v-for="(itemBg, indexBg) in tabDataBackground" :key="'bg&' + indexBg">
              <span>{{ itemBg.cn }}</span>
              <div :class="itemBg.en" @click="toggleBackgroundFunc(itemBg.en)"></div>
            </div>

          </div>

          <!-- 人像美颜 -->
          <div class="fair-box" v-show="tabTypeHeader === 'fair' && !notWatermarkImage">

            <div class="fair-item reset-fair-item" @click="resetNowFair()">
              <img src="https://files.wondercv.com/cvs/reset-icon.png" class="icon"/>
              <span>使用原图</span>
            </div>

            <div class="fair-item">
              <i class="iconfont iconmopi"></i>
              <span>磨皮</span>
              <el-slider class="slider" v-model="nowFair.skinsoft" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.skinsoft }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconzuiba"></i>
              <span>嘴巴</span>
              <el-slider class="slider" v-model="nowFair.mouthlarge" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.mouthlarge }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconmeibai"></i>
              <span>美白</span>
              <el-slider class="slider" v-model="nowFair.skinwhite" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.skinwhite }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconshoulian"></i>
              <span>瘦脸</span>
              <el-slider class="slider" v-model="nowFair.facelift" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.facelift }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconyanjingfangda"></i>
              <span>左眼</span>
              <el-slider class="slider" v-model="nowFair.leyelarge" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.leyelarge }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconyanjingfangda"></i>
              <span>右眼</span>
              <el-slider class="slider" v-model="nowFair.reyelarge" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.reyelarge }}%</div>
            </div>

            <div class="fair-item">
              <i class="iconfont iconliangyan"></i>
              <span>亮眼</span>
              <el-slider class="slider" v-model="nowFair.coseye" :step="20" :show-tooltip="false" :format-tooltip="formatSliderFunc" @change="toggleFairFunc()"></el-slider>
              <div class="fair-item-counter">{{ nowFair.coseye }}%</div>
            </div>
          </div>

          <!-- 正装样式 -->
          <div class="clothes-box" v-show="tabTypeHeader === 'clothes' && !notWatermarkImage">

            <div class="clothes-tab-box">
              <span class="clothes-tab" :class="{'active': tabTypeClothes === 'girl'}" @click="toggleTabClothesFunc('girl')">女装</span>
              <span class="clothes-tab" :class="{'active': tabTypeClothes === 'boy'}" @click="toggleTabClothesFunc('boy')">男装</span>
            </div>

            <div class="clothes-item-box" v-show="tabTypeClothes === 'girl'">

              <div class="clothes-item no-clothes" :class="{'active': nowClothesId === -1}" @click="toggleClothesFunc(-1)">
                <span class="no-clothes"></span>
                <span>无正装</span>
              </div>

              <div class="clothes-item" :class="{'active': nowClothesId === itemClothes.id}" v-for="(itemClothes, indexClothes) in tabDataClothes.girl_list" :key="'clothes&' + indexClothes" @click="toggleClothesFunc(itemClothes.id)">
                <img :src="itemClothes.url" alt="" draggable="false">
              </div>

            </div>

            <div class="clothes-item-box" v-show="tabTypeClothes === 'boy'">

              <div class="clothes-item no-clothes" :class="{'active': nowClothesId === -1}" @click="toggleClothesFunc(-1)">
                <span class="no-clothes"></span>
                <span>无正装</span>
              </div>

              <div class="clothes-item" :class="{'active': nowClothesId === itemClothes.id}" v-for="(itemClothes, indexClothes) in tabDataClothes.boy_list" :key="'clothes&' + indexClothes" @click="toggleClothesFunc(itemClothes.id)">
                <img :src="itemClothes.url" alt="" draggable="false">
              </div>

            </div>

          </div>

          <div class="preview-box" v-show="notWatermarkImage">
            <p class="sub-title">你可以根据不同的简历布局来裁剪照片，以呈现最好展示效果。（不影响本地保存）</p>
            <div class="editor-main-box">
              <vueCropper class="vueCropper2"
                          ref="vueCropper2"
                          :img="notWatermarkImage"
                          :fixed="true"
                          :canMove="true"
                          :autoCrop="true"
                          :centerBox="true"
                          :autoCropWidth="110"
                          :autoCropHeight="132"
                          :fixedNumber="[110, 132]" @real-time="realTime"/>
              <div class="preview-img convention">
                <img :src="cropperImage || notWatermarkImage"/>
                <div class="text-explain">常规简历布局</div>
              </div>
              <div class="preview-img circle">
                <div class="image-box" :style="{backgroundImage: `url(${cropperImage || notWatermarkImage})`}">
                </div>
                <div class="text-explain">大头像简历布局</div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- 底部按钮 -->
    <div class="btn-box">
      <div class="btn" @click="goToCutFunc()" v-if="!notWatermarkImage">重新裁剪</div>
      <div class="btn" @click="debounce(() => { buyMember() }, 300)" v-if="!userPhotoCount && !isMembership">下载并保存到简历</div>
      <div class="btn" @click="debounce(() => { goToPayFunc() }, 300)" v-else-if="!notWatermarkImage">下载并保存到简历</div>
      <div class="btn" @click="debounce(() => { handleClickSaveCv() }, 300)" v-else>保存到简历</div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import { VueCropper } from 'vue-cropper'
import { get_tUser } from '@/assets/js/util'
import { mapState, mapMutations, mapActions } from 'vuex'
import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  props: {
    originPhoto: { // 无水印的照片 用于作为参数调接口
      type: String,
      default: null
    },
    watermarkedPhoto: { // 有水印的照片 用于页面展示
      type: String,
      default: null
    },
    cutPhotoFile: { // 裁剪完之后的原图
      type: String,
      default: null
    },
    // 用户可制作证件照次数
    userPhotoCount: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      /**
       * tab 类型
       */
      tabTypeHeader: 'background', // 当前 tab 操作类型 可能的值： 1. background 更改底色 2. fair 人像美颜 3. clothes 正装样式, 4. 简历预览 preview
      tabTypeClothes: 'girl', // 正装样式下 tab 操作类型 可能的值： 1. girl 女装 2. boy 男装
      resetFair: { //默认美颜
        skinsoft: 0, // 磨皮
        mouthlarge: 0, // 嘴巴
        skinwhite: 0, // 美白
        facelift: 0, // 瘦脸
        leyelarge: 0, // 左眼
        reyelarge: 0, // 右眼
        coseye: 0 // 亮眼
      },
      /**
       * 页面渲染数据
       */
      tabDataBackground: [ // 更改底色 可选数据
        {
          cn: '蓝色',
          en: 'blue'
        },
        {
          cn: '白色',
          en: 'white'
        },
        {
          cn: '浅蓝',
          en: 'baby_blue'
        },
        {
          cn: '红色',
          en: 'red'
        },
        {
          cn: '深蓝',
          en: 'navy_blue'
        },
        {
          cn: '灰色',
          en: 'grey'
        }
      ],
      tabDataFair: [], // 人像美颜 可选数据
      tabDataClothes: { // 正装样式 可选数据
        boy_list: [],
        girl_list: []
      },
      /**
       * 记录当前活跃值
       */
      nowBackground: 'white', // 当前底色 默认 white
      nowFair: { // 当前美颜
        skinsoft: 40, // 磨皮
        mouthlarge: 60, // 嘴巴
        skinwhite: 60, // 美白
        facelift: 60, // 瘦脸
        leyelarge: 60, // 左眼
        reyelarge: 60, // 右眼
        coseye: 60 // 亮眼
      },
      nowClothesId: -1, // 当前 正装 id
      _c_t: null, // 用户 jwt
      cropperImage: ''
    }
  },
  computed: {
    ...mapState('editor', ['notWatermarkImage']),
    ...mapState('me', [ 'personInfo' ]),
    isMembership(){
      return this.personInfo.is_membership
    },
  },
  components: {VueCropper},
  mixins: [ componentsMixin ],
  created () {
    // console.log(1111, this.cutPhotoFile)
    this._c_t = get_tUser().c_t || ''
    // 获取用户信息
    this.getBaseInfoFunc()
    // 获取正装模板列表
    this.getPhotoTemplateFunc()
  },
  methods: {
    // 显示支付弹窗
    goToPayFunc () {
      this.togglePayDialogVisibleFunc(true)
    },
    // 重新裁剪 裁剪的图是二维码上传成功的图
    goToCutFunc () {
      this.$emit('goToCut')
    },
    // 控制支付弹窗的出现和隐藏
    togglePayDialogVisibleFunc (val) {
      this.$emit('togglePayDialogVisible', val)
    },
    // 切换顶部 tab
    toggleTabHeaderFunc (val) {
      this.tabTypeHeader = val
    },
    // 切换正装 tab
    toggleTabClothesFunc (val) {
      this.tabTypeClothes = val
    },
    // 切换 底色
    toggleBackgroundFunc (val) {
      this.nowBackground = val
      if(!val){
        // 走重置逻辑
        this.resetPhotoSetting()
        return
      }
      // 照片美颜
      this.editPhotoBeautyFunc()
    },
    // 切换 美颜
    toggleFairFunc () {
      // 照片美颜
      this.editPhotoBeautyFunc()
    },
    // 切换 正装
    toggleClothesFunc (val) {
      this.nowClothesId = val
      // 照片美颜
      this.editPhotoBeautyFunc()
    },
    // 格式化 滑块值
    formatSliderFunc (val) {
      return val / 100
    },
    // 值除以 100
    formatFair (val) {
      let obj = {}
      let isNull = true
      for(let prop in val) {
        // console.log(11111, val[prop])
        obj[prop] = val[prop] / 100
        if(obj[prop] !== 0){
          isNull = false
        }
      }
      if(isNull){
        obj = null
      }
      return obj
    },
    // 切换 loading 状态
    toggleLoadingFunc (val) {
      this.$emit('toggleLoading', val)
    },
    // 照片美颜
    async editPhotoBeautyFunc (options) {
      this.toggleLoadingFunc(true)
      try {
        let params = options || {
          source_file: this.originPhoto, // 无水印的图片地址
          background_color: this.nowBackground, // 背景色
          fair_level: this.formatFair(this.nowFair), // 美颜参数
          clothes: this.nowClothesId === -1 ? null : this.nowClothesId // 正装 id
        }
        if(!params.fair_level){
          delete params.fair_level
        }


        let res = await api.portrait.editPhotoBeauty(params)
        if (res.code === 1000) {
          // 照片检测通过
          if (res.data.status === 'success') {
            // 存储 图片名 和 正装id 用于最后保存证件照时 获取无水印图片
            let paramsNoWatermarkedPhoto = {
              fileName: res.data.file_name,
              clothesId: this.nowClothesId
            }
            this.$emit('updateNoWatermarkedPhoto', paramsNoWatermarkedPhoto)
            // 更新左侧预览图片
            let paramsUpdatePhoto = {
              origin: res.data.source_file, // 拿到无水印的照片
              watermarked: res.data.file_name_wm // 拿到有水印的照片
            }
            this.$emit('updateBeautyPhoto', paramsUpdatePhoto)
            // 成功 toast
            this.$message.success('修改成功')
          // 照片检测不通过
          } else if (res.data.status === 'error') {
            this.$message.error('未通过照片检测')
          }
        } else {
          this.$message.error(res.msg || res.message)
        }
        this.toggleLoadingFunc(false)
      } catch (error) {
        console.log(error)
        this.toggleLoadingFunc(false)
      }
    },
    // 获取用户信息
    async getBaseInfoFunc () {
      try {
        let res = await api.account.getUsersBasicInfo(this._c_t,{})
        if (res.code === 1000) {
          this.tabTypeClothes = (res.data.gender === '男' ? 'boy' : 'girl')
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取正装模板列表
    async getPhotoTemplateFunc () {
      try {
        let res = await api.portrait.getPhotoTemplateData()
        if (res.code === 1000) {
          this.tabDataClothes = res.data
        } else {
          console.log(res.message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //实时预览
    realTime(data){
      this.$refs.vueCropper2.getCropData(file => {
        this.cropperImage = file
      })
    },
    handleClickSaveCv(){
      this.$emit('save-cv')
    },

    // 重置美颜参数
    resetNowFair(){
      this.nowFair = JSON.parse(JSON.stringify(this.resetFair))
      // 重新生成照片设置
      this.resetPhotoSetting()
    },

    // 重置图片设置
    async resetPhotoSetting(){
      let params = {
        file: this.cutPhotoFile,
        background_color: this.nowBackground || null, // 背景色
        fair_level: this.formatFair(this.nowFair), // 美颜参数
        clothes: this.nowClothesId === -1 ? null : this.nowClothesId // 正装 id
      }
      // 照片美颜
      this.editPhotoBeautyFunc(params)
    },

    // 去买会员
    buyMember(){
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'upVip',
        browseType: 'avatar'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";

</style>
